import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import SuccessfullAddItemText from 'bento-ordering/base/components/Snackbar/helpers/SuccessfullAddItemText';

const Container = styled('div')({
  display: 'flex',
  alignItems: 'flex-start'
});

const Image = styled('img')({
  width: '57px',
  height: '48px',
  borderRadius: '0.25rem',
  objectFit: 'cover'
});

const ItemTextWithImage = styled('span')({
  marginTop: '0.25rem',
  marginBottom: '1rem',
  paddingLeft: '1rem',
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

const ItemTextWithoutImage = styled('span')({
  marginBottom: '1rem',
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

const SuccessfulAddSnackbarMessage = ({ item, image, cartItems }) => (
  <Container>
    {image ? (
      <>
        <div>
          <Image src={image} alt={item} />
        </div>
        <ItemTextWithImage>
          <SuccessfullAddItemText cartItems={cartItems} item={item} />
        </ItemTextWithImage>
      </>
    ) : (
      <ItemTextWithoutImage>
        <SuccessfullAddItemText cartItems={cartItems} item={item} />
      </ItemTextWithoutImage>
    )}
  </Container>
);

SuccessfulAddSnackbarMessage.propTypes = {
  cartItems: PropTypes.array.isRequired,
  item: PropTypes.string.isRequired,
  image: PropTypes.string
};

SuccessfulAddSnackbarMessage.defaultProps = {
  cartItems: [],
  item: '',
  image: null
};

export default SuccessfulAddSnackbarMessage;
